import { render } from "./NovaTag.vue?vue&type=template&id=71579780&scoped=true"
import script from "./NovaTag.vue?vue&type=script&lang=js"
export * from "./NovaTag.vue?vue&type=script&lang=js"

import "./NovaTag.vue?vue&type=style&index=0&id=71579780&scoped=true&lang=css"
import "./NovaTag.vue?vue&type=style&index=1&id=71579780&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71579780"]])

export default __exports__